import { Type } from '@sinclair/typebox';
import { OwnerProfileSchema } from '../owner-profile.js';
export const PoolCreatorSchema = Type.Object({
    address: Type.String(),
    owner: Type.Optional(OwnerProfileSchema),
    balanceInToken: Type.Optional(Type.String()),
    buyVolumeInUsd: Type.Optional(Type.String()),
    sellVolumeInUsd: Type.Optional(Type.String()),
    buys: Type.Optional(Type.Number()),
    sells: Type.Optional(Type.Number()),
    lastTx: Type.Optional(Type.Object({
        at: Type.String(),
        amountInToken: Type.String(),
        amountInUsd: Type.String(),
        operation: Type.Union([Type.Literal('buy'), Type.Literal('sell')]),
    })),
    lpTokensBurned: Type.Optional(Type.String()),
    quoteTokensBurned: Type.Optional(Type.String()),
    lpTokensBurnedPercentage: Type.Optional(Type.String()),
    quoteTokensBurnedPercentage: Type.Optional(Type.String()),
    funding: Type.Optional(Type.Object({
        at: Type.String(),
        by: Type.String(),
        amount: Type.String(),
        token: Type.String(),
    })),
});
//# sourceMappingURL=pool-creator.js.map